import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function ClassroomsPage() {
  return <InstituteCrudPage config={entityConfigs['classrooms']} />;
}
